import React from 'react';
import { useLocation } from 'react-router-dom';

import { Button } from '@swyftx/aviary/atoms/Button';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body, Heading } from '@swyftx/aviary/atoms/Typography';
import { SwyftxFull } from '@swyftx/aviary/icons/outlined';

import { useNavigateRoute } from 'src/lib/navigation/hooks';
import { NavigationURLs } from 'src/lib/navigation/types';

import { experiments } from './Experiment.data';

export const ExperimentResult: React.FC = () => {
  const params = new URLSearchParams(useLocation().search);
  const experimentId = params.get('id') ?? '';
  const { navigate } = useNavigateRoute();

  const experiment = experiments[experimentId];

  if (!experiment) {
    navigate(NavigationURLs.Dashboard);
    return null;
  }

  return (
    <FlexLayout
      alignItems='center'
      justifyContent='center'
      direction='column'
      spacing={24}
      className='h-full w-full p-24'
    >
      <SwyftxFull className='w-[256px] text-color-text-primary' />
      <Heading size='h1' className='text-center'>
        {experiment.headline}
      </Heading>
      <Heading size='h2' className='text-center'>
        {experiment.subHeadline}
      </Heading>
      <Body size='large' className='max-w-[650px] text-center' color='secondary'>
        {experiment.body}
      </Body>
      <Button size='lg' onClick={() => navigate(NavigationURLs.Dashboard)}>
        {experiment.button}
      </Button>
    </FlexLayout>
  );
};
